import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    ArrowLeftOutlined,
    HomeOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';
import { useHotel } from '../context/HotelContext';
import Disclaimer from './Disclaimer';

import { Button } from 'antd';
import { HOTEL_IMAGE_URL } from '../constants';
import { useLanguage } from '../context/LanguageContext';
const Header = (props) => {
    const { hotelDetails } = useHotel();
    const navigate = useNavigate();
    const { t } = useLanguage();
    const { showBack, popupData, backBtnHandler, disclaimerText = '' } = props;

    const [isDisclaimer, setisDisclaimer] = useState(false);

    const openDisclaimer = () => setisDisclaimer(true);
    const closeDisclaimer = () => setisDisclaimer(false);
    return (
        <div
            className='bg-gray-900 header-new flex items-center w-full sticky top-0 z-50 min-h-16 max-h-16'
            style={{ direction: 'ltr' }}
        >
            <div className='flex items-center justify-between  w-full h-full px-4'>
                <div className='flex items-center gap-4 h-full justify-between w-full'>
                    {showBack && (
                        <Button
                            icon={<ArrowLeftOutlined />}
                            className='shadow-sm'
                            size='large'
                            onClick={
                                backBtnHandler
                                    ? backBtnHandler
                                    : () => navigate(-1)
                            }
                        >
                            {t['back_btn_text']}
                        </Button>
                    )}

                    {hotelDetails.logo && (
                        <img
                            src={`${HOTEL_IMAGE_URL}${hotelDetails.logo}`}
                            alt={`${hotelDetails?.name} logo`}
                            className='max-h-12 w-full object-contain'
                        />
                    )}
                    <div className='flex gap-4 items-center'>
                        <Button
                            icon={<HomeOutlined />}
                            className='shadow-sm '
                            size='large'
                            onClick={() => navigate('/')}
                        >
                            {t['back_to_home_btn_text']}
                        </Button>

                        {popupData && (
                            <div className='' onClick={openDisclaimer}>
                                <InfoCircleOutlined
                                    style={{
                                        fontSize: '22px',
                                        color: 'rgb(203 201 199)',
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Disclaimer
                onClose={closeDisclaimer}
                open={isDisclaimer}
                disclaimerText={disclaimerText}
            />
        </div>
    );
};

export default Header;
